module.exports = __webpack_public_path__ + "static/media/people.020789ca.svg";